import { Metamodel } from '../../base/model';
import { AdsDataset, IAdsDatasetArgs, AdsDatasetType } from './AdsDatasetModel';
import { IAdsAdlsGen2CommonProperties } from '../../../../lib/model/dataShare/Datasets/AdsAdlsGen2CommonProperties';

interface IAdsAdlsGen2FileDatasetProperties extends IAdsAdlsGen2CommonProperties  {
    fileName: string;
    path: string;
}

export type IAdsAdlsGen2FileDatasetArgs = Omit<IAdsDatasetArgs<IAdsAdlsGen2FileDatasetProperties>, 'datasetType'>;

@Metamodel.model({
    name: 'AdsAdlsGen2FileDataset'
})
export class AdsAdlsGen2FileDataset extends AdsDataset<IAdsAdlsGen2FileDatasetProperties> {
    public constructor(args: IAdsAdlsGen2FileDatasetArgs) {
        super({
            ...args,
            datasetType: AdsDatasetType.AdlsGen2File
        });
    }
    public get resourceId(): string {
        const path = this.properties.path ? this.properties.path + '/' : '';
        return `${this.properties.storageAccountName}/${this.properties.filesystemName}/${path}${this.properties.fileName}`;
    }
}
